import { SearchProvider } from "../search-provider"

export function EducatorsSearchProvider({
  children,
  url = "/search/gateway/educators/query",
}: React.PropsWithChildren<{ url?: string }>) {
  return (
    <SearchProvider
      source={[
        "name",
        "listing_type",
        "nested_classes",
        "speciality_attributes",
        "tags",
        "relief_availability",
      ]}
      url={url}
    >
      {children}
    </SearchProvider>
  )
}
